/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import ChangeEmail from './ChangeEmail';

import RouteNames from '../appAuthorized/RouteNames';
import { useNavigate } from '../hooks/useNavigate';
import { useActiveUser } from '../hooks/useUser';

const AccountChangeEmail: React.FC = () => {
  const [, navActions] = useNavigate();
  const [, userActions] = useActiveUser();

  return (
    <ChangeEmail
      defaultEmail=""
      submitEmail={(email, callback) => {
        userActions.requestEmailChange(email)
          .then(callback);
      }}
      goBack={() => {
        navActions.goBackTo(RouteNames.accountSettings());
      }}
    />
  );
};

export default AccountChangeEmail;
